import { render, staticRenderFns } from "./adminLoginLayout.vue?vue&type=template&id=3a785878"
import script from "./adminLoginLayout.vue?vue&type=script&lang=js"
export * from "./adminLoginLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports